<template>
<div>

    <div v-if="loading" class="text-center">
        <i class="fa fa-circle-o-notch fa-spin"></i> Loading
    </div>
    <div v-else>
        <vue-headful :title="form.form_name+' [Inspection Forms] :: MeritEHS'" />

        <div class="container d-print-none">
            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
                        <router-link :to="`/inspections/forms`">
                            Inspections Forms
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
                        <router-link :to="`/inspections/forms/view/${form.inspection_form_id}`">
                            {{ form.form_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                        <i class="fa fa-file-pdf-o"></i> PDF
                    </li>
                </ol>
            </h4>
        </div>
        <div class="container bg-white d-print-none py-4 mb-4">
            <div class="alert alert-info">
                <strong>How to Export as PDF:</strong>
                <ol>
                    <li>On your browser, there should be a "File" or "Options" tab with a "Print" option. You may also hold down the "Ctrl" key and press the "P" key.</li>
                    <li>This will bring up the print page options box. There should be an option called "Select Printer" or "Destination".</li>
                    <li>Select "Save as PDF" or "Adobe PDF".</li>
                    <li>Click "Save" or "Print". This will open your file explorer and let you save it to your computer as a PDF.</li>
                </ol>

                <div>
                    <strong>PDF Settings:</strong>
                    <ol>
                        <li class="mb-1" v-if="pdfLogo">
                            <span>Show/Hide Logo:</span>
                            <select v-model="showLogo">
                                <option :value="true">Show Logo</option>
                                <option :value="false">Hide Logo</option>
                            </select>
                            <span class="small">Show/Hide your company logo on the Inspection PDF report.</span>
                        </li>
                        <li class="mb-1" v-if="enable_insp_scmm == 1">
                            <span>Show/Hide Safety Comittee Sections:</span>
                            <select v-model="showSafetyCommittee">
                                <option :value="1">Show Safety Committee</option>
                                <option :value="0">Hide Safety Committee</option>
                            </select>
                            <span class="small"></span>
                        </li>
                        <li class="mb-1" v-if="custom_field_sections != null && custom_field_sections.length > 0">
                            <span>Show/Hide Custom Fields</span>
                            <select v-model="showCustomFields">
                                <option :value="true">Show Custom Fields</option>
                                <option :value="false">Hide Custom Fields</option>
                            </select>
                            <span class="small">You can hide the Safety Committee, Minues, Options/Questions.</span>
                        </li>
                        <li class="mb-1">
                            <span>Page Break for Each Section</span>
                            <select v-model="insertPageBreak">
                                <option :value="true">Insert Page Break</option>
                                <option :value="false">Omit Page Break</option>
                            </select>
                            <span class="small">If inserted, each section will start on it's own page.</span>
                        </li>
                    </ol>
                </div>
            </div>
        </div>

        <div class="container bg-white py-4">
            <div class="row" v-if="pdfLogo && showLogo === true" style="margin-bottom: 50px;">
                <div class="col-md-3">
                    <img :src="pdfLogo" class="img-fluid" />
                </div>
            </div>

            <h5>Inspection Details</h5>
            <table class="table table-bordered table-sm table-condensed">
                <tbody>
                    <tr>
                        <td width="25%">Form Name:</td>
                        <td>{{ form.form_name }}</td>
                    </tr>
                    <tr>
                        <td width="25%">Jobsite:</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td width="25%"># of Employees On Site:</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td width="25%">Inspection Date:</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td width="25%">General Contractor:</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td width="25%">Superintendent:</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td width="25%">Corrective Action Required When Status = {{ labelNonCompliant }}:</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>

            <template v-if="custom_field_sections && custom_field_sections.length > 0 && showCustomFields === true">
                <div v-for="section in custom_field_sections">
                    <h5 v-if="section.section_name">{{ section.section_name }}</h5>
                    <table class="table table-bordered table-sm table-condensed">
                        <tbody>
                            <tr v-for="field in section.fields">
                                <td width="25%">{{ field.label }}:</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>

            <template v-if="personnel.length > 0">
                <h5>Personnel</h5>
                <table class="table table-bordered table-sm table-condensed">
                    <tbody>
                        <tr v-for="field in personnel">
                            <td width="25%">{{ field.field_label }}:</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </template>

            <template v-if="enable_insp_scmm == 1 && showSafetyCommittee == 1">
                <h5 class="mt-4">Safety Committee</h5>
                <template v-if="safety_committee_members">
                    <div v-for="member in safety_committee_members">
                        {{ member.name }} | {{ member.craft }} | {{ member.company }}
                    </div>
                </template>
                <template v-else>
                    -- No Safety Committee Meeting Held --
                </template>

                <h5 class="mt-4">Safety Committee Meeting Minutes</h5>
                <template v-if="safety_committee_members">
                    <div class="mb-4">
                        <div class="text-muted">A. Discuss inspection results and status of project Corrective Actions:</div>
                        <div class="">
                            <div v-if="form.scmm_status_of_actions" v-html="form.scmm_status_of_actions"></div>
                            <div v-else>--</div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="text-muted">B. Project incidents and lessons learned:</div>
                        <div class="">
                            <div v-if="form.scmm_lessons_learned" v-html="form.scmm_lessons_learned">
                            </div>
                            <div v-else>--</div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="text-muted">C. Safety concerns and suggestions voiced by any other project team member(s):</div>
                        <div class="">
                            <div v-if="form.scmm_suggested_safety" v-html="form.scmm_suggested_safety">
                            </div>
                            <div v-else>--</div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="text-muted">D. Upcoming safety sensitive activities/tasks:</div>
                        <div class="">
                            <div v-if="form.scmm_upcoming_activities" v-html="form.scmm_upcoming_activities">
                            </div>
                            <div v-else>--</div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="text-muted">E. Proactive safety measures being utilized throughout the project, and/or individuals who have displayed HSE leadership:</div>
                        <div class="">
                            <div v-if="form.scmm_proactive_measures" v-html="form.scmm_proactive_measures">
                            </div>
                            <div v-else>--</div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="text-muted">F. Any other relevant topic discussed by the safety committee:</div>
                        <div class="">
                            <div v-if="form.scmm_other" v-html="form.scmm_other">
                            </div>
                            <div v-else>--</div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    -- No Safety Committee Meeting Held --
                </template>
                <hr/>
            </template>

            <h5 class="mt-4">Additional Comments</h5>
            <table class="table table-bordered table-sm table-condensed mb-4">
                <tbody>
                    <td style="height: 300px;"></td>
                </tbody>
            </table>

            <div v-for="section in form.sections" :style="'page-break-before: '+(insertPageBreak == true ? 'always' : 'auto')+';'">
                <table class="table table-bordered table-sm table-condensed">
                    <thead>
                        <tr>
                            <th colspan="2">{{ section.DisplayOrder }}. {{ section.SectionName }}</th>
                            <th>{{ labelCompliant }}</th>
                            <th>{{ labelNonCompliant }}</th>
                            <th>{{ labelNA }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="element in section.elements">
                            <td width="6%">{{ section.DisplayOrder }}.{{ element.DisplayOrder }}</td>
                            <td>{{ element.ElementText }}</td>
                            <td width="12%"></td>
                            <td width="12%"></td>
                            <td width="12%"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import moment from 'moment-timezone';

export default {
    data: function() {
        return {
            loading: true,
            inspection_form_id: this.$route.params.id,
            form: {},
            sections: [],
            safety_committee_members: [],
            showLogo: true,
            showCustomFields: true,
            insertPageBreak: true,
            showCompliant: 1,
            showNA: 1,
            showSafetyCommittee: 1,
            imagesLoading: false,
            pdfs_proccessing: false,
            result_labels: null,
            pdfLogo: null,
            custom_field_sections: [],
            personnel: [],
            enable_insp_scmm: null,
        }
    },

    computed: {

        labelCompliant(){
            //Check if set
            if(this.result_labels && this.result_labels.compliant)
            {
                return this.result_labels.compliant;
            }

            //Default
            return 'Compliant';
        },

        labelNonCompliant(){
            //Check if set
            if(this.result_labels && this.result_labels.noncompliant)
            {
                return this.result_labels.noncompliant;
            }

            //Default
            return 'Non-Compliant';
        },

        labelNA(){
            //Check if set
            if(this.result_labels && this.result_labels.na)
            {
                return this.result_labels.na;
            }

            //Default
            return 'N/A';
        },
    },

    methods: {

        getForm() {
            //Build the URL
            var url = '/inspections/forms/view/' + this.inspection_form_id + '?pdf=true';

            //Get the data
            this.$http
                .get(url)
                .then(response => {
                    //Set all the data
                    this.form = response.data.form;
                    this.result_labels = response.data.result_labels;
                    this.personnel = response.data.personnel;
                    this.custom_field_sections = response.data.custom_field_sections;
                })
                .catch(response => {

                })
                .then(() => {
                    //Set
                    this.loading = false;
                });
        },

    },
    mounted() {
        //Get the inspections
        this.getForm();
    }
}
</script>
<style scoped>
.break-protect {
    page-break-inside: avoid;
}
</style>